// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__JGesz","content":"LayoutSettings_content__CIPg6"};